module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAANlBMVEUAAAAwMDAwMDAzMzMzMzMyMjIzMzMyMjIyMjIyMjIzMzMzMzMzMzMyMjIzMzMyMjIyMjIzMzOvgMcVAAAAEXRSTlMAIEBQX2Bvf5CfoK+wwM/Q7yU0rXsAAABwSURBVDjL7ZOxFoAgCEURNcw05f9/tiHsSDnU1OKdQC7nMPgATvzOit2BIvKDtZ97eQyIiEEa3wmpbRERbdKkTsg8IH8U4MYUpvC38PJXF2PKSGjBYQRAHgSnRY8tgOVB9K7wVrdUKaM+2hd9YWn7B+quFhnMguRNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgnew/i-phone.png
// module id = NEKT
// module chunks = 1